'use client'

import { QUIZ_PAGE_VARIANT } from '../lib/quiz-ui'
import { useQuizzes } from '../hooks/useQuizzes'

import { Card, CardBody, CardHeader, CardTitle } from '@/shared/ui/Card'
import { NotFoundAlert } from '@/shared/ui/NotFoundAlert'
import { Page } from '@/shared/ui/Page'

import { QuizListItem } from './QuizListItem'

export function QuizzesListPage() {
  const { data: quizzes, isLoading } = useQuizzes()

  return (
    <Page variant={QUIZ_PAGE_VARIANT}>
      <div className="flex w-full min-w-0 max-w-full flex-col items-center gap-4 px-2 sm:px-0">
        <Card variant={QUIZ_PAGE_VARIANT} className="w-full max-w-2xl">
          <CardHeader>
            <CardTitle>Quizzes</CardTitle>
          </CardHeader>
          <CardBody>
            <p className="text-center text-sm font-medium text-[#7F7FAD]">
              Avaliações rápidas com perguntas sorteadas. Cada acerto vale
              pontos.
            </p>

            {isLoading ? (
              <div className="flex flex-col gap-3 pt-4">
                {[0, 1, 2].map(index => (
                  <div
                    key={index}
                    className="h-[76px] w-full animate-pulse rounded-xl bg-white/40"
                  />
                ))}
              </div>
            ) : !quizzes || quizzes.length === 0 ? (
              <NotFoundAlert
                title="Nenhum quiz por aqui"
                text="Quando a sua escola liberar um quiz, ele aparece nesta lista."
              />
            ) : (
              <div className="flex flex-col gap-3 pt-4">
                {quizzes.map(quiz => (
                  <QuizListItem key={quiz.id} quiz={quiz} />
                ))}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    </Page>
  )
}
